"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.array.find");
var _roleCertificationApplication = require("@/api/user/roleCertificationApplication/roleCertificationApplication");
var _vuex = require("vuex");
var _indexHotOpt = _interopRequireDefault(require("./components/indexHotOpt"));
var _indexHotAtt = _interopRequireDefault(require("./components/indexHotAtt"));
var _appDetDlg = _interopRequireDefault(require("./components/appDetDlg "));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _booking = require("@/api/bookSpace/booking");
var _vue = require("@handsontable/vue");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "roleCertificationApplication",
  components: {
    HotColumn: _vue.HotColumn,
    indexHotAtt: _indexHotAtt.default,
    indexHotOpt: _indexHotOpt.default,
    initDetail: _appDetDlg.default,
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      sysRole: [],
      filterForm: {
        companyType: '',
        companyName: '',
        usci: '',
        companyAbbrev: '',
        companyAddress: '',
        country: '',
        province: '',
        city: '',
        businessLicenseScanningCopy: '',
        simisCompanyCode: '',
        simisCompanyNameCn: '',
        simisCompanyNameEn: ''
      },
      total: 0,
      tableData: [],
      selectedRow: {},
      hotSettings: {
        dragCheck: true,
        height: 'calc(100vh - 580px)',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: false,
        fixedColumnsLeft: 1,
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      listQuery: {
        currentPage: 1,
        pageSize: 10
      },
      initDialogVisible: false
    };
  },
  methods: {
    roleCodeRenderer: function roleCodeRenderer(instance, td, row, col, prop, value, cellProperties) {
      var role = this.sysRole.find(function (role) {
        return role.codeValue === value;
      });
      var displayValue = this.language === 'zh' ? role === null || role === void 0 ? void 0 : role.displayValueCn : role === null || role === void 0 ? void 0 : role.displayValue;
      Handsontable.dom.empty(td);
      Handsontable.dom.fastInnerText(td, displayValue);
      Handsontable.dom.addClass(td, 'htCenter');
      return td;
    },
    loadInitialData: function loadInitialData() {
      var _this = this;
      this.loading = (0, _utils.load)();
      (0, _roleCertificationApplication.queryInfoRoleList)().then(function (res) {
        if (res.success) {
          _this.sysRole = res.data.map(function (role) {
            return {
              codeValue: role.roleCode,
              displayValueCn: role.roleName,
              displayValue: role.roleNameEn
            };
          });
        }
      }).catch(function (err) {}).finally(function () {
        _this.loading.close();
      });
    },
    handRefresh: function handRefresh() {
      this.queryListInfo();
    },
    handleSubmit: function handleSubmit(row) {
      var currentLine = this.$refs.hotTable.getSelected();
      var editStatus = true;
      this.$router.push({
        path: '/userCenter/roleApplicationAuthentication',
        query: {
          ebSysAccountPortRoleAuth: JSON.stringify(currentLine),
          ebSysAccount: JSON.stringify(this.filterForm),
          editStatus: JSON.stringify(editStatus)
        }
      });
    },
    handleViewDetail: function handleViewDetail(row) {
      var data = this.$refs.hotTable.getSelected();
      this.selectedRow = data;
      this.initDialogVisible = true;
    },
    handleCancel: function handleCancel(row) {
      var _this2 = this;
      var data = this.$refs.hotTable.getSelected();
      this.$confirm(this.$t('roleCertificationApplication.confirmContent'), this.$t('confirmMsg.title'), {
        confirmButtonText: this.$t('confirmMsg.confirm'),
        cancelButtonText: this.$t('confirmMsg.close'),
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      }).then(function () {
        _this2.loading = (0, _utils.load)();
        (0, _roleCertificationApplication.getCancel)(data.officeRoleAuthId).then(function (response) {
          if (response.success) {
            _this2.queryListInfo();
            _this2.$message({
              message: _this2.$t('roleCertificationApplication.cancelSuccess'),
              type: 'success'
            });
          } else {
            _this2.$message({
              message: response.errorMessages[0] || _this2.$t('roleCertificationApplication.errMsg'),
              type: 'error'
            });
          }
        }).catch(function (err) {
          _this2.$message({
            message: err.errorMessages[0] || _this2.$t('roleCertificationApplication.errMsg'),
            type: 'error'
          });
        }).finally(function () {
          _this2.loading.close();
        });
      }).catch(function () {}).finally(function () {
        _this2.loading.close();
      });
    },
    handEditCompanyInfo: function handEditCompanyInfo() {
      if (this.filterForm.parentid != null && this.filterForm.parentid != '') {
        this.$message({
          message: this.$t('roleCertificationApplication.notEdit'),
          type: 'warning'
        });
        return;
      }
      var editStatus = false;
      this.$router.push({
        path: '/userCenter/roleApplicationAuthentication',
        query: {
          ebSysAccount: JSON.stringify(this.filterForm),
          editStatus: JSON.stringify(editStatus)
        }
      });
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.queryListInfo();
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTable.resizeTo();
    },
    queryListInfo: function queryListInfo() {
      var _this3 = this;
      this.loading = (0, _utils.load)();
      (0, _roleCertificationApplication.queryListInfo)(this.listQuery).then(function (res) {
        if (res.success) {
          _this3.filterForm = res.data.ebSysAccount;
          _this3.total = res.data.ebSysAccountPortRoleAuthList.totalRecord;
          _this3.tableData = res.data.ebSysAccountPortRoleAuthList.records.sort(function (a, b) {
            return new Date(b.applyDate) - new Date(a.applyDate);
          });
        } else {
          _this3.$message.error(res.errorMessages[0]);
        }
      }).finally(function () {
        _this3.loading.close();
      });
    },
    handleDownload: function handleDownload() {
      var _this4 = this;
      this.loading = (0, _utils.load)();
      (0, _booking.setDownloadFile)(this.filterForm.businessLicenseScanningCopy).then(function (res) {
        console.log(res);
        var url = window.URL.createObjectURL(new Blob([res]));
        var link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', res.fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).finally(function () {
        _this4.loading.close();
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;
    this.$nextTick(function () {
      _this5.resizeHotTable();
      _this5.loadInitialData();
      _this5.queryListInfo();
    });
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])), {}, {
    companyTypeText: function companyTypeText() {
      switch (this.filterForm.companyType) {
        case 1:
          return this.$t('roleCertificationApplication.cargoOwner');
        case 2:
          return this.$t('roleCertificationApplication.forwarder');
        case 3:
          return this.$t('roleCertificationApplication.transportTeam');
        default:
          return this.filterForm.companyType;
      }
    }
  })
};